import i from"styled-components";import{theme as t}from"../../../../theme.js";const o=i.div`
  a {
    text-decoration: unset;
    color: inherit;
  }
  hr {
    width: 100%;
    margin: 0;
    border-top: 1px solid #eeeeee;
  }
  .overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: #0000004d;
    top: 0;
    left: 0;
    z-index: 999;
    cursor: auto;
  }
  .user-link {
    width: fit-content;
  }
`,e=i.div`
  position: relative;
  cursor: pointer;   
  .dropdown {
    position: absolute;
    top: 42px;
    right: 0;
    z-index: 1000;
    width: 348px;
    padding: ${t.spacing*4}px;
    background-color: ${t.colors.shades[0]};
    border-radius: ${t.radius}px;
    transition: all .2s ease-in-out;
    &.close {
      opacity: 0;
      visibility: hidden;
      transform: translate(10px, -10px);
    }
    &.open {
      opacity: 1;
      visibility: visible;
      transform: translate(0px, 0px);
    }
  }
  @media screen and (max-width: ${t.breakpoints.md}) {
    .dropdown {
      width: 100%;
      height: 100vh;
      box-sizing: border-box;
      position: fixed;
      top: 0;
      left: 0;
      border-radius: unset;
      &.close {
        transform: translateX(100px);
      }
      &.open {
        transform: translateX(0px);
      }
    }
  }
`,r=i.div`
  display: flex;
  flex-direction: column;
  gap: ${t.spacing*6}px;
  .list-label {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: ${t.colors.gray[400]};
  }
  &.small-gap {
    gap: ${t.spacing*4}px;
  }
`,n=i.div`
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 16px;
  align-items: center;
  > span {
    font-size: 18px;
    font-weight: 700;
    color: ${t.colors.gray[900]};
  }
`,s=i.button`
  position: absolute;
  top: 8px;
  right: 8px;
  border: none;
  padding: 0;
  background-color: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: flex-end;
  width: 40px;
  height: 40px;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${t.colors.gray[500]};
    }
  }
  @media screen and (min-width: ${t.breakpoints.md}) {
    display: none;
  }
`;export{s as CloseButton,o as Container,e as DropdownButton,r as ListContainer,n as UserContainer};
